/***
 *
 *   LOADER
 *   Infinite spinning animation for loading states
 *
 **********/

import { ClassHelper } from "components/lib";
import Orbit from "./images/loading.gif";
import Style from "./loader.module.scss";

export function Loader(props) {
  const loaderStyle = ClassHelper(Style, props);

  return (
    <div className={loaderStyle}>
      <img src={Orbit} className={Style.orbit} alt="Orbit Spinner" />
    </div>
  );
}
